export const dashboardStats = {
  profileCompletion: 78,
  visibilityMode: 'Sessiz Kariyer',
  pendingRequests: 3,
  activeConversations: 2,
  newOpportunities: 6,
  profileStatus: 'Onaylandı',
};

export const pendingRequests = [
  {
    id: 1,
    spaType: 'Premium Spa & Wellness',
    city: 'İstanbul',
    position: 'Masaj Terapisti',
    salaryBand: '70K-90K TL',
    workModel: 'Tam zamanlı',
    hoursLeft: 48,
    urgency: 'normal',
  },
  {
    id: 2,
    spaType: 'Lüks Otel Spa',
    city: 'Antalya',
    position: 'SPA Terapisti',
    salaryBand: '90K-120K TL',
    workModel: 'Sezonluk',
    hoursLeft: 12,
    urgency: 'high',
  },
  {
    id: 3,
    spaType: 'Termal Wellness Merkezi',
    city: 'Kayseri',
    position: 'Hamam Terapisti',
    salaryBand: '60K-70K TL',
    workModel: 'Part-time',
    hoursLeft: 68,
    urgency: 'normal',
  },
];

export const activeConversations = [
  {
    id: 1,
    spaType: 'Boutique Spa',
    city: 'İstanbul',
    status: 'görüşme başladı',
    lastMessage: 'Merhaba, profilinizi inceledik. Çalışma saatlerimiz esnek.',
    lastDate: '20 Mayıs 2026',
    phoneShared: false,
  },
  {
    id: 2,
    spaType: 'Resort Spa',
    city: 'Antalya',
    status: 'telefon paylaşıldı',
    lastMessage: 'Telefon numaranızı paylaştınız. En kısa sürede size ulaşacağız.',
    lastDate: '19 Mayıs 2026',
    phoneShared: true,
  },
];

export const newOpportunities = [
  {
    id: 1,
    spaType: 'Premium Spa',
    city: 'İstanbul',
    workModel: 'Tam zamanlı',
    salaryBand: '70K-90K TL',
    ssg: 'Zorunlu',
    accommodation: 'İstiyorum',
    expertise: 'Masaj, Aromaterapi',
    verified: true,
  },
  {
    id: 2,
    spaType: 'Lüks Otel',
    city: 'Antalya',
    workModel: 'Sezonluk',
    salaryBand: '90K-120K TL',
    ssg: 'Müzakereye Açığım',
    accommodation: 'İstiyorum',
    expertise: 'Hamam, Kese',
    verified: true,
  },
  {
    id: 3,
    spaType: 'Termal Merkez',
    city: 'Kayseri',
    workModel: 'Part-time',
    salaryBand: '60K-70K TL',
    ssg: 'Fark Etmez',
    accommodation: 'İstemiyorum',
    expertise: 'Masaj',
    verified: false,
  },
  {
    id: 4,
    spaType: 'Wellness Club',
    city: 'İstanbul',
    workModel: 'Tam zamanlı',
    salaryBand: '45K-60K TL',
    ssg: 'Zorunlu',
    accommodation: 'İstemiyorum',
    expertise: 'Spa Terapisi',
    verified: true,
  },
  {
    id: 5,
    spaType: 'Güzellik Merkezi',
    city: 'İzmir',
    workModel: 'Part-time',
    salaryBand: '45K-60K TL',
    ssg: 'Müzakereye Açığım',
    accommodation: 'İstemiyorum',
    expertise: 'Cilt Bakımı, Masaj',
    verified: false,
  },
  {
    id: 6,
    spaType: 'Hotel Spa',
    city: 'Bodrum',
    workModel: 'Sezonluk',
    salaryBand: '70K-90K TL',
    ssg: 'Fark Etmez',
    accommodation: 'İstiyorum',
    expertise: 'Hamam, Masaj',
    verified: true,
  },
];

export const notifications = [
  {
    id: 1,
    type: 'request',
    message: 'Premium Spa & Wellness size iletişim talebi gönderdi.',
    time: '15 dakika önce',
    read: false,
  },
  {
    id: 2,
    type: 'match',
    message: 'Yeni bir işletme fırsatı size uygun görünüyor.',
    time: '2 saat önce',
    read: false,
  },
  {
    id: 3,
    type: 'system',
    message: "Profil doluluk oranınız %78. Mini bio ekleyerek %85'e çıkarabilirsiniz.",
    time: '1 gün önce',
    read: true,
  },
];

export const therapistProfile = {
  name: 'Ayşe Yılmaz',
  phone: '555 *** ** 42',
  city: 'İstanbul',
  gender: 'Kadın',
  expertise: ['Masaj Terapisi', 'Aromaterapi', 'Hamam'],
  experience: '3-5 yıl',
  pastExperience: ['Otel Spa', 'Wellness Merkezi'],
  preferredWorkAreas: ['Otel Spa', 'Termal Merkez'],
  cityPreferences: ['İstanbul', 'Antalya'],
  salaryBand: '70K-90K TL',
  ssgPreference: 'Müzakereye Açığım',
  accommodation: 'İstiyorum',
  workModel: 'Tam zamanlı',
  kesePreference: 'Müzakereye Açığım',
  bio: '5 yıllık deneyimli masaj terapistiyim. Aromaterapi ve hamam alanlarında uzmanım. Profesyonel, güvenilir ve müşteri odaklı çalışmayı ilke edindim.',
  hasPhoto: false,
  hasIdDoc: true,
  idDocStatus: 'Onaylandı',
  hasCertificate: true,
  certificateStatus: 'İncelemede',
  visibilityMode: 'Sessiz Kariyer',
};

export const requests = [
  {
    id: 1,
    spaType: 'Premium Spa & Wellness',
    city: 'İstanbul',
    summary: 'Deneyimli masaj terapisti arıyoruz. Aromaterapi bilgisi tercih sebebi.',
    salaryBand: '70K-90K TL',
    ssg: 'Zorunlu',
    accommodation: 'İstiyorum',
    workHours: '09:00 - 21:00 (vardiyalı)',
    verified: true,
    hoursLeft: 48,
  },
  {
    id: 2,
    spaType: 'Lüks Otel Spa',
    city: 'Antalya',
    summary: 'Sezonluk hamam ve masaj terapisti. Konaklama sağlanıyor.',
    salaryBand: '90K-120K TL',
    ssg: 'Müzakereye Açığım',
    accommodation: 'İstiyorum',
    workHours: '10:00 - 22:00',
    verified: true,
    hoursLeft: 12,
  },
  {
    id: 3,
    spaType: 'Termal Wellness Merkezi',
    city: 'Kayseri',
    summary: 'Part-time masaj terapisti aranıyor. Esnek çalışma saatleri.',
    salaryBand: '60K-70K TL',
    ssg: 'Fark Etmez',
    accommodation: 'İstemiyorum',
    workHours: '12:00 - 18:00',
    verified: false,
    hoursLeft: 68,
  },
];

export const conversationsList = [
  {
    id: 1,
    spaType: 'Boutique Spa',
    city: 'İstanbul',
    status: 'görüşme başladı',
    lastMessage: 'Merhaba, profilinizi inceledik. Çalışma saatlerimiz esnek.',
    lastDate: '20 Mayıs 2026',
    unread: true,
  },
  {
    id: 2,
    spaType: 'Resort Spa',
    city: 'Antalya',
    status: 'telefon paylaşıldı',
    lastMessage: 'Telefon numaranızı paylaştınız. En kısa sürede size ulaşacağız.',
    lastDate: '19 Mayıs 2026',
    unread: false,
  },
  {
    id: 3,
    spaType: 'Wellness Club',
    city: 'İzmir',
    status: 'beklemede',
    lastMessage: 'Maaş beklentinizi öğrenebilir miyiz?',
    lastDate: '18 Mayıs 2026',
    unread: true,
  },
];

export const favoritesList = [
  {
    id: 1,
    spaType: 'Premium Spa & Wellness',
    city: 'İstanbul',
    workModel: 'Tam zamanlı',
    salaryBand: '70K-90K TL',
    expertise: 'Masaj, Aromaterapi',
    isActive: true,
    closedLabel: null,
  },
  {
    id: 2,
    spaType: 'Lüks Otel Spa',
    city: 'Antalya',
    workModel: 'Sezonluk',
    salaryBand: '90K-120K TL',
    expertise: 'Hamam, Kese',
    isActive: false,
    closedLabel: 'Personel ihtiyacı kapandı',
  },
];

export const historyData = {
  active: [
    {
      id: 1,
      spaType: 'Boutique Spa',
      city: 'İstanbul',
      status: 'görüşme başladı',
      startDate: '15 Mayıs 2026',
    },
  ],
  pending: [
    {
      id: 2,
      spaType: 'Termal Wellness',
      city: 'Kayseri',
      status: 'beklemede',
      requestDate: '18 Mayıs 2026',
    },
  ],
  completed: [
    {
      id: 3,
      spaType: 'Güzellik Merkezi',
      city: 'İzmir',
      status: 'süreç kapandı',
      endDate: '10 Mayıs 2026',
      reason: 'Yanıt Süresi Doldu',
    },
  ],
  hired: [
    {
      id: 4,
      spaType: 'Hotel Spa',
      city: 'Bodrum',
      status: 'işe başladı',
      startDate: '1 Mart 2026',
    },
  ],
  archived: [
    {
      id: 5,
      spaType: 'Resort Spa',
      city: 'Antalya',
      status: 'uygun bulunmadı',
      archiveDate: '15 Nisan 2026',
    },
  ],
};